/**
 * Numeric page IDs used with PermissionProvider / GET /menu/permissions/:pageId.
 * Must match backend configuration.
 */
export const PAGE_IDS = {
  APPLICANT_SEARCH: 1,
  APPLICANT_PROFILE: 2,
  APPLICANT_HISTORY: 3,
  APPLICANT_ADDITIONAL_INFO: 4,
  VACANCY_SEARCH: 5,
  LINKEDIN_SEARCH: 6,
  VACANCY_ADD: 7,
  VACANCY_JD_ADD: 8,
  VACANCY_UPLOAD_ADD: 9,
  VACANCY_EDIT: 10,
  VACANCY_JD_EDIT: 11,
  VACANCY_UPLOAD_EDIT: 12,
  VIEW_VACANCY: 13,
  APPLICANT_ADD: 16,
  /** Applicant profile: Jira comments API (GET …/jira-comments). */
  APPLICANT_JIRA_COMMENTS: 24,
  /** Applicant profile: Messages tab (GET …/messages). */
  APPLICANT_MESSAGES: 25,
  /** User Profile (Profile Info tab); align with `docs/frontend.md` RBAC matrix. */
  USER_PROFILE: 28,
  /** Send Message test page — temporary testing page for WhatsApp outbound flow. */
  SEND_MESSAGE: 29,
} as const;

export type PageId = (typeof PAGE_IDS)[keyof typeof PAGE_IDS];

/**
 * Feature permission IDs returned by the permissions API (hasPermission).
 */
export const PERMISSION_IDS = {
  APPLICANT_PROFILE_NAVIGATE: 1,
  APPLICANT_NAME_CLICK: 2,
  APPLICANT_PROFILE_EDIT: 3,
  APPLICANT_HISTORY_EDIT: 4,
  APPLICANT_ADDITIONAL_INFO_EDIT: 5,
  VACANCY_TITLE_NAVIGATE: 6,
  VACANCY_EDIT_DRAFT: 7,
  VACANCY_DELETE: 8,
  VACANCY_CLONE: 9,
  LINKEDIN_ADD_APPLICANT: 10,
  VACANCY_FORM_SAVE_ADD: 11,
  VACANCY_QUESTIONS_SAVE_ADD: 12,
  VACANCY_JD_SAVE_ADD: 13,
  VACANCY_JD_SECTION_ADD: 14,
  VACANCY_UPLOAD_SAVE_ADD: 15,
  VACANCY_FORM_SAVE_EDIT: 16,
  VACANCY_QUESTIONS_SAVE_EDIT: 17,
  VACANCY_JD_SAVE_EDIT: 18,
  VACANCY_JD_SECTION_EDIT: 19,
  VACANCY_UPLOAD_SAVE_EDIT: 20,
  VIEW_VACANCY_EDIT_APPROVED: 21,
  VIEW_VACANCY_EDIT: 28,
  VACANCY_SEARCH_PUBLISH: 29,
  VACANCY_SEARCH_UNPUBLISH: 30,
  VACANCY_SEARCH_WITHDRAW: 31,
  APPLICANT_VACANCY_CODE_EDIT: 32,
  APPLICANT_COUNTRY_EDIT: 33,
  APPLICANT_ADD: 25,
  VACANCY_EDIT_APPROVED: 27,
  /** Upload form: post-approval actions. */
  VACANCY_UPLOAD_APPROVAL_ACTION: 26,
  /** Edit / Save controls on User Profile Info. */
  USER_PROFILE_EDIT: 35,
  /** Send Message test page access. */
  SEND_MESSAGE_ACCESS: 36,
} as const;

export type PermissionId = (typeof PERMISSION_IDS)[keyof typeof PERMISSION_IDS];
